export default (opt = {}) => {
    let editor = opt.editor,
        styleManager = editor.StyleManager;

    styleManager.addType(window.PMW.emails.styles.ID_LIST, {
        /**
         * @param {object} props
         * @param {string} props.property single property to use for all list items
         * @param {function} props.onRender Function called on render
         * @param {object[]} props.list
         * @param {string} props.list.name
         * @param {string} props.list.value
         * @param {string} props.list.classes
         * @param {string} props.list.property custom property for a single list item only
         * @param {function} props.list.callback
         * @param {string} props.list.parentClasses
         * @param {grapesjs.Component} [props.component]
         * @param change
         * @return {HTMLDivElement}
         */
        create({props, change}) {
            // default, list,
            const container = document.createElement('div'),
                titleEl = document.createElement('span'),
                el = document.createElement('ul'),
                component = props.component || editor.getSelected();

            let isToggleable,
                title;

            container.className = 'pmw-list-style-type-container';
            titleEl.className = 'pmw-list-style-type-title';
            el.className = 'pmw-list-style-type';

            if (typeof props.toggleable === 'boolean') {
                isToggleable = props.toggleable;
            } else {
                isToggleable = false;
            }

            if (typeof props.title === 'string') {
                title = props.title;
            } else {
                title = props.property;
            }

            titleEl.innerHTML = title;

            container.appendChild(titleEl);

            props.list.forEach((item) => {
                let property = item.property || props.property,
                    parentClasses = item.parentClasses || '',
                    li = document.createElement('li'),
                    icon = document.createElement('i'),
                    label = document.createElement('label'),
                    selectable = item.selectable !== undefined ? item.selectable : true;

                li.title = item.name;
                li.className = 'pmw-list-item-style-type ' + parentClasses;
                li.setAttribute('data-value', item.value);
                icon.className = 'pmw-icon -square size-icon-16 -transparent ' + item.classes;
                label.className = 'pmw-list-item-style-type-label body-xs' + (item.label ? '' : ' _hidden');
                label.innerHTML = item.label;

                if (props.defaults === item.value && selectable) {
                    li.className += ' -selected';
                }

                if (isToggleable && isLiPreselected(component, li, property, item.value)) {
                    li.className += ' -selected';
                }

                li.appendChild(icon);
                li.appendChild(label);
                el.appendChild(li);
                PMW.onClick($(li), null, function () {
                    let t = $(this);

                    if (isToggleable) {
                        t.toggleClass('-selected');
                    } else {
                        t.addClass('-selected').siblings('li').removeClass('-selected');
                    }

                    saveListData(component, t.parents('ul'), props.property);
                    item.callback.call(this);
                });
            });

            container.appendChild(el);

            return container;
        },
        emit({props}, {el, event, complete}) {
        },

        update({value, el}) {
        }
    });

    function getListDataKey(component, listProperty) {
        let componentId = component.ccid;
        return 'pmw-list-' + listProperty + '-' + componentId;
    }

    function saveListData(component, ul, listProperty) {
        let key = getListDataKey(component, listProperty);

        let values = $.map(ul.find('li'), function (li) {
            let t = $(li),
                obj = {};
            obj[t.attr('data-value')] = t.hasClass('-selected');

            return obj;
        });

        $(document).data(key, values);
    }

    function isLiPreselected(component, li, listProperty, listValue) {
        return isValueSet(component, listProperty, listValue) || isListDataSet(component, li, listProperty);
    }

    function isValueSet(component, property, value) {
        const styles = component?.getStyle() || {};
        return styles.hasOwnProperty(property) && styles[property].split(' ').includes(value);
    }

    function isListDataSet(component, li, listProperty) {
        let key = getListDataKey(component, listProperty),
            data = $(document).data(key),
            t = $(li),
            isDataSet = false;

        if (data && data.length > 0) {

            data.forEach(liObject => {
                let key = t.attr('data-value');

                if (typeof liObject[key] === "boolean" && liObject[key] === true) {
                    isDataSet = true;
                }
            });
        }

        return isDataSet;
    }
}